<template>
  <a-modal v-model="visible" title="批量调整" class="batchChangeModal" width="680px" :afterClose="afterClose">
    <a-spin :spinning="accountLoading || phaseLoading">
      <a-form-model layout="vertical" ref="form" :model="form" class="edp-form" :rules="rules" v-if="isShow">
        <div class="line-2">
          <a-form-model-item prop="prjoid">
            <span slot="label">项目</span>
            <a-select showSearch optionFilterProp="children" allowClear v-model="form.prjoid" @change="onChangePrj">
              <a-select-option v-for="item in projectList" :key="item.oid" :code="item.project_code" :value="item.oid">
                {{ item.project_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">阶段</span>
            <a-select allowClear :disabled="!form.prjoid || !disabled.phase_oid"
                      v-model="form.phase_oid">
              <a-select-option v-for="item in phaseList" :key="item.oid" :value="item.oid">
                {{ item.phase_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">负责人</span>
            <a-select allowClear showSearch optionFilterProp="children" v-model="form.issue_owner"
                      :disabled="!form.prjoid || !disabled.issue_owner">
              <a-select-option v-for="item in accountList" :value="item.user_oid" :key="item.user_oid">
                {{ item.name }} {{ item.title ? '-' + item.title : '' }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="协同人">
            <a-select showSearch optionFilterProp="children" mode="multiple" v-model="form.issue_assist"
                      :disabled="!form.prjoid || !disabled.issue_assist">
              <a-select-option v-for="item in accountList" :value="item.user_oid" :key="item.user_oid">
                {{ item.title ? item.name + '-' + item.title : item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">任务状态</span>
            <a-select allowClear v-model="form.issue_status"
                      :disabled="!form.prjoid || !disabled.issue_status">
              <a-select-option v-for="item in task_status" :key="item.cat_code" :value="item.cat_code">
                {{ item.cat_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">任务进度</span>
            <a-input-number style="width: 100%;" :min="0" :max="100" v-model="form.complete_percent"
                            :disabled="!form.prjoid || !disabled.complete_percent"></a-input-number>
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">计划开始</span>
            <a-date-picker format="YYYY/MM/DD" valueFormat="YYYY/MM/DD" v-model="form.schedule_start_date"
                           style="width: 100%"
                           :disabled="!form.prjoid || !disabled.schedulr_start_date" />
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">计划结束</span>
            <a-date-picker format="YYYY/MM/DD" valueFormat="YYYY/MM/DD" v-model="form.schedule_end_date"
                           style="width: 100%"
                           :disabled="!form.prjoid || !disabled.schedule_end_date" />
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">实际开始</span>
            <a-date-picker format="YYYY/MM/DD" valueFormat="YYYY/MM/DD" v-model="form.actual_start_date"
                           style="width: 100%"
                           :disabled="!form.prjoid || !disabled.actual_start_date" />
          </a-form-model-item>
          <a-form-model-item>
            <span slot="label">实际结束</span>
            <a-date-picker format="YYYY/MM/DD" valueFormat="YYYY/MM/DD" v-model="form.actual_end_date"
                           style="width: 100%" :disabled="!form.prjoid || !disabled.actual_end_date" />
          </a-form-model-item>
        </div>
        <a-form-model-item label="标签" prop="issue_tag">
          <a-checkbox-group :disabled="!form.prjoid || !disabled.issue_tag" v-model="form.issue_tag"
                            :options="task_coding.map(item => item.cat_name)">
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
    <template #footer>
      <div class="modal-footer">
        <a-space>
          <a-button @click="visible = false">
            取消
          </a-button>
          <a-button :loading="submitLoading" type="primary" @click="submit">
            确定
          </a-button>
        </a-space>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { fetch } from "@/utils/request";
import catMixin from "@/utils/mixins/catMixin";
import EdpCheckboxGroup from "@/components/e-form/edp-checkbox-group.vue";

export default {
  name: "batchChangeModal",
  components: { EdpCheckboxGroup },
  mixins: [catMixin],
  emits: ["reload"],
  data() {
    return {
      isShow: true,
      cat: {
        issue_bstatus: []
      },
      visible: false,
      projectList: [],
      phaseList: [],
      accountList: [],
      form: {
        oid: "",
        prjoid: "",
        phase_oid: "",
        issue_owner: "",
        issue_assist: [],
        issue_status: "",
        complete_percent: "",
        schedule_start_date: "",
        schedule_end_date: "",
        actual_start_date: "",
        actual_end_date: "",
        issue_tag: [],
        prj_code: ""
      },
      disabled: {
        phase_oid: false,
        issue_owner: false,
        issue_assist: false,
        issue_status: false,
        complete_percent: false,
        schedulr_start_date: false,
        schedule_end_date: false,
        actual_start_date: false,
        actual_end_date: false,
        issue_tag: false,
      },
      rules: {
        prjoid: [
          { required: true, message: '请选择项目', trigger: 'blur' },
        ],
      },
      backups: {},
      submitLoading: false,
      phaseLoading: false,
      accountLoading: false,
      task_coding: [],
      task_status: [],
    }
  },
  created() {
    this.backups = JSON.parse(JSON.stringify(this.form))
    this.getTaskCoding()
    this.getTaskStatus()
  },
  methods: {
    // 获取任务编码
    async getTaskCoding() {
      const res = await fetch('post', '/cpy/cat/issuetags', {
        project_oid: this.form.prjoid,
        cat_type: 'issue_tags'
      })
      this.task_coding = res.data
    },
    // 获取任务状态
    async getTaskStatus() {
      const res = await fetch('post', '/cpy/cat/issuestatus', {
        temp10: this.form.prj_code || '全局'
      })
      this.task_status = res.data.datas
    },
    // 判断权限
    isPermission(code) {
      if(this.$hasP("T_UPDATEALL",this.form.prjoid)){
        return true
      }
      return this.$hasP(code, this.form.prjoid)
    },
    // 关闭弹窗
    afterClose() {
      this.$refs.form.resetFields()
    },
    submit() {
      this.submitLoading = true
      fetch("post", "/prj/issue/mutimove", {
        ...this.form,
        issue_assist: this.form.issue_assist.join("/"),
        issue_tag: this.form.issue_tag.join(",")
      }).then(res => {
        if (res.status === 0) {
          this.$message.success("批量修改成功")
          this.$emit("reload")
          this.visible = false
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    open(oid) {
      this.getProjectList()
      this.form = JSON.parse(JSON.stringify(this.backups))
      this.form.oid = oid
      this.visible = true
    },
    async onChangePrj(value, e) {
      this.form.prj_code = e.data.attrs?.code
      //获取标签
      this.getTaskCoding()
      this.getTaskStatus()

      if (!this.form.prjoid) return;
      this.form.issue_owner = ""
      this.form.issue_assist = []
      this.form.phase_oid = ""
      this.form.product_oid = ""
      // this.getDemand()
      this.getAccount()
      this.getPhaseList()
      await this.$store.dispatch('getPrjPermissions', this.form.prjoid)
      this.disabled.phase_oid = this.isPermission('T_UPDATE_PHASE_OID')
      this.disabled.issue_owner = this.isPermission('T_UPDATE_ISSUE_OWNER')
      this.disabled.issue_assist = this.isPermission('T_UPDATE_ISSUE_ASSIST')
      this.disabled.issue_status = this.isPermission('T_UPDATE_ISSUE_STATUS')
      this.disabled.complete_percent = this.isPermission('T_UPDATE_COMPLETE_PERCENT')
      this.disabled.schedulr_start_date = this.isPermission('T_UPDATE_SCHEDULR_START_DATE')
      this.disabled.schedule_end_date = this.isPermission('T_UPDATE_SCHEDULE_END_DATE')
      this.disabled.actual_start_date = this.isPermission('T_UPDATE_ACTUAL_START_DATE')
      this.disabled.actual_end_date = this.isPermission('T_UPDATE_ACTUAL_END_DATE')
      this.disabled.issue_tag = this.isPermission('T_UPDATE_ISSUE_TAG')
      // this.getProductList()
    },
    getProjectList() {
      fetch("post", "/prj/retrieve").then(res => {
        if (res.status === 0) {
          this.projectList = res.data.datas
        }
      })
    },
    getAccount() {
      this.accountLoading = true
      fetch("post", "/prj/userlist/list", { prjoid: this.form.prjoid }).then(res => {
        if (res.status === 0) {
          console.log("batchChangeModal", res)
          this.accountList = res.data
        }
      }).finally(() => this.accountLoading = false)
    },
    getPhaseList() {
      this.phaseLoading = true
      return fetch("post", "/prj/phase/retrieve", {
        page_size: 999,
        prjoid: this.form.prjoid
      }).then(res => {
        if (res.status === 0) {
          this.phaseList = res.data.datas
        }
      }).finally(() => this.phaseLoading = false)
    },
  }
}
</script>

<style lang="less" scoped>
.batchChangeModal {

}
</style>
